import moment from "moment";
import joinData from "../data.json";
import { setIsSkip } from "../store/authSlice";
import { accessEnums } from "../data/index";
import { DEFAULT_ROLE_NAME } from "../data/index";
import store from "../store";
import { setSubscriptionExpired } from "../store/subscriptionExpired";
import { toast } from "react-toastify"
import { red } from "@mui/material/colors";
export const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};
export const formatMobileNumber = (mobileNo) => {
  if (!mobileNo) return "";
  const str = mobileNo?.toString();
  return `${str.substring(0, 3)} ${str.substring(3, 6)} ${str.substring(
    6,
    9
  )} ${str.substring(9, str?.length)}`;
};
export const CreateFormData = (data) => {
  const formData = new FormData();
  for (let key in data) {
    formData.append(key, data[key]);
  }
  return formData;
};

export const convertIntoLocalTime = (date) => {
  return moment.utc(date).local();
};

export const formRegEx = /([a-z])([A-Z])/g;
export const formRegExReplacer = "$1 $2";

export var recordsLimit = 10;

export const dateDifference = (date) => {
  let duration = moment.duration(moment().diff(date));
  let daysDiff = duration.asDays().toFixed(0);
  return +daysDiff;
};

export const startEndMonthDifference = (startDate, endDate) => {
  const d1 = new Date(startDate);
  const d2 = new Date(endDate);

  const yearsDiff = d2.getFullYear() - d1.getFullYear();
  const monthsDiff = d2.getMonth() - d1.getMonth();

  return yearsDiff * 12 + monthsDiff;
};

export const findCurrentPackage = (packages, monthDiff) => {
  const matchedPackage = packages?.find(
    (pkg) => pkg?.packageDurationMonths === monthDiff
  );

  if (matchedPackage) {
    return matchedPackage;
  }

  return packages?.reduce((maxPkg, currentPkg) =>
    currentPkg?.packageDurationMonths > maxPkg?.packageDurationMonths
      ? currentPkg
      : maxPkg
  );
};

// Corrected version
export const getResponsiveItemsAdvanced = (
  items,
  screenWidth,
  fallbackComponent,
  breakpoints,
  itemRenderer,
  moreItemsClass
) => {
  if (!items?.length) {
    return fallbackComponent;
  }

  const itemComponents = items.map((item, ind) => itemRenderer(item, ind));
  let activeBreakpoint = breakpoints.find((bp) => screenWidth < bp.maxWidth);
  // If no breakpoint matches, set default or return all items
  if (!activeBreakpoint) {
    activeBreakpoint = { maxItems: 10 }; // or return itemComponents if you want all items
  }

  // If items are within limit, return all items without "more" indicator
  if (itemComponents.length <= activeBreakpoint.maxItems) {
    return itemComponents;
  }
  const visibleItems = itemComponents.slice(0, activeBreakpoint.maxItems);
  const remainingCount = items.length - activeBreakpoint.maxItems;

  // Only show "more" indicator if there are remaining items
  if (remainingCount > 0) {
    const moreIndicator = (
      <span key="more" className={moreItemsClass}>
        +{remainingCount} more
      </span>
    );
    return [...visibleItems, moreIndicator];
  }

  return visibleItems;
};

export const dateFromToFormatter = (fromDateTime, toDateTime) => {
  return moment(fromDateTime).format("Do MMM, YYYY") ===
    moment(toDateTime).format("Do MMM, YYYY")
    ? moment(fromDateTime).format("Do MMM, YYYY")
    : `${moment(fromDateTime).format("Do MMM, YYYY")} to ${moment(
      toDateTime
    ).format("Do MMM, YYYY")}`;
};

export const timeFromToFormatter = (fromDateTime, toDateTime) => {
  return moment(fromDateTime).format("hh:mm A") ===
    moment(toDateTime).format("hh:mm A")
    ? moment(fromDateTime).format("hh:mm A")
    : `${moment(fromDateTime).format("hh:mm A")} to ${moment(toDateTime).format(
      "hh:mm A"
    )}`;
};

export const capitalizeFirstLetter = (l) =>
  l.charAt(0).toUpperCase() + l.slice(1);

export const hidePhoneNumber = (phoneNumber) => {
  const numDigitsToHide = phoneNumber?.length - 5;

  const hiddenPart = "*".repeat(numDigitsToHide);
  const firstPart = phoneNumber.slice(0, 1);
  const lastPart = phoneNumber.slice(-4);

  const hiddenPhoneNumber = `${firstPart}${hiddenPart}${lastPart}`;

  return hiddenPhoneNumber;
};

export const fileDownloadFunction = (name, data, type) => {
  const blob = new Blob([data], { type });
  const fileUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = fileUrl;
  link.setAttribute("download", name);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export function dataURLtoFile(data, type) {
  const binaryData = atob(data);
  const byteNumbers = new Uint8Array(binaryData.length);
  for (let i = 0; i < binaryData.length; i++) {
    byteNumbers[i] = binaryData.charCodeAt(i);
  }
  return byteNumbers;
}

export function amenityNameFormatter(ammenityName, prefix, unitName) {
  if (prefix !== undefined && unitName !== undefined) {
    const displayName = prefix ? ` ${prefix}-${unitName}` : ` - ${unitName}`;
    return ammenityName + displayName;
  } else {
    return "";
  }
}

export const filteredDataHandler = (data) => {
  var filtered = {};
  for (var i = 0; i < data?.length; i++) {
    if (data[i].ammenityName in filtered) {
      filtered = {
        ...filtered,
        [data[i].ammenityName]: [...filtered[data[i].ammenityName], data[i]],
      };
    } else {
      filtered = { ...filtered, [data[i].ammenityName]: [data[i]] };
    }
  }
  const result = Object.entries(filtered);
  return result;
};

export const filterCompleteCommunityList = (data) => {
  if (data?.length !== 1) {
    const joinLogin =
      data?.length > 1 &&
      data?.find(
        (item) =>
          item?.roleName?.toLowerCase() !== DEFAULT_ROLE_NAME &&
          (item?.isSuperUser ? (item?.isSetupCompleted ? true : false) : true)
      );

    if (joinLogin !== undefined) {
      if (joinLogin?.roleId === null || joinLogin?.roleId === 0) {
        return { ...joinLogin, menu: joinData?.joinMenuList };
      } else {
        var ids = new Set(joinLogin?.menu?.map((d) => d.code));
        var mergedMenu = [
          ...joinLogin?.menu,
          ...joinData?.joinMenuList.filter((d) => !ids.has(d.code)),
        ];
        return { ...joinLogin, menu: mergedMenu };
      }
    } else {
      return data?.find(
        (item) => item?.roleName?.toLowerCase() === DEFAULT_ROLE_NAME
      );
    }
  } else {
    return data?.find(
      (item) => item?.roleName?.toLowerCase() === DEFAULT_ROLE_NAME
    );
  }

  // if (joinLogin?.userType === "Resident") {
  //   if (joinLogin?.roleId === null) {
  //     return { ...joinLogin, menu: joinData?.joinMenuList };
  //   }
  //   else {
  //     return joinLogin;
  //   }
  // }
  // else if (joinLogin?.userType === "Outsider") {
  //   return { ...joinLogin, menu: joinData?.joinMenuList };
  //   // return joinLogin;
  // }
};

const menuForJoin = joinData?.joinMenuList?.filter((item) =>
  ["CB_PAYMENT_BILL", "CB_ACCESS"].includes(item?.parentCode)
);

// export const newFunctionTest = (data, communityId) => {

//   console.log("Data coming for set", data)
//   if (data?.length > 1) {
//     if (!communityId) {
//       const myCommunity = data?.find(
//         (item) =>
//           item?.roleName?.toLowerCase() !== DEFAULT_ROLE_NAME &&
//           (item?.roleName === "super user"
//             ? item?.isSetupCompleted
//               ? true
//               : false
//             : true)
//       );

//       return myCommunity
//     }
//     else {

//       const mycommunity = data.find(
//         (item) =>
//           item?.communityId === communityId &&
//           item?.roleName?.toLowerCase() !== DEFAULT_ROLE_NAME &&
//           (item?.roleName === "super user"
//             ? !!item?.isSetupCompleted
//             : true)
//       );
//       return mycommunity ? mycommunity : data?.find(
//         (item) =>
//           item?.roleName?.toLowerCase() !== DEFAULT_ROLE_NAME &&
//           (item?.roleName === "super user"
//             ? item?.isSetupCompleted
//               ? true
//               : false
//             : true)
//       );
//     }
//     // if (myCommunity !== undefined) {
//     // if (myCommunity?.roleId !== null && myCommunity?.roleId !== 0) {
//     //   if (myCommunity?.userType === "Resident") {
//     //     // var ids = new Set(myCommunity?.menu?.map(d => d.code));
//     //     // var mergedMenu = [...myCommunity?.menu, ...joinData?.joinMenuList.filter(d => !ids.has(d.code))];
//     //     // return { ...myCommunity, menu: mergedMenu };
//     //     // const appendedData = insertMenuItems([myCommunity], menuForJoin);

//     //     // let appendedData = appendEleInToArray(myCommunity?.menu, menuForJoin);
//     //     //delete approvals list if access is not defined
//     //     // appendedData = deleteSubModulesItem(appendedData, "CB_ACCESS", "CB_APPROVALS");

//     //     console.log("object Abvc", { ...myCommunity, menu: myCommunity?.menu });
//     //     return { ...myCommunity, menu: myCommunity?.menu };
//     //   }
//     //   else {
//     //     return myCommunity;
//     //   }
//     // }
//     // else if (myCommunity?.userType === "Resident") {
//     //   return { ...myCommunity, menu: joinData?.joinMenuList };
//     // }

//     // else if (myCommunity?.roleName === null) {
//     //   return { ...myCommunity, menu: myCommunity?.menu }
//     // };

//     // return { ...myCommunity, menu: myCommunity?.menu };
//     // }
//   }
//   return data?.find(
//     (item) => item?.roleName?.toLowerCase() === DEFAULT_ROLE_NAME
//   );
// };

export const newFunctionTest = (data, communityId) => {
  console.log("Data coming for set", data);

  if (!Array.isArray(data) || data.length === 0) return undefined;

  const isValidRole = (item) =>
    item?.roleName?.toLowerCase() !== DEFAULT_ROLE_NAME &&
    (item?.roleName === "super user" ? !!item?.isSetupCompleted : true);

  if (data.length > 1) {
    // Case: communityId not provided → pick first valid community
    if (!communityId) {
      const findCommunity = data.find(isValidRole);
      console.log("Find Community", findCommunity)
      checkSubscriptionExpiry(findCommunity)
      return findCommunity
    }

    // Case: communityId provided
    const myCommunity = data.find(
      (item) => item?.communityId === communityId && isValidRole(item)
    );
    const communityResult = myCommunity || data.find(isValidRole);
    checkSubscriptionExpiry(communityResult)
    return communityResult
  }

  // Fallback: return default role if only one item or no match
  const defaultCommunityResult = data.find(
    (item) => item?.roleName?.toLowerCase() === DEFAULT_ROLE_NAME
  );
  console.log("DEFAULT COMMUNITY RESULT", defaultCommunityResult)
  // checkSubscriptionExpiry(defaultCommunityResult)
  return defaultCommunityResult
};


export const valueIntoNumber = (value) => {
  if (!value) value = "";
  return Number(value?.replace(/[^\d]/g, ""));
};
export const valueIntoCommaSeprated = (value) => {
  return Number(String(value)?.replace(/[^\d]/g, "")).toLocaleString();
};
export const filterQPCompany = (data) => {
  // debugger;
  return data?.filter(
    (item) => item?.roleName?.toLowerCase() !== DEFAULT_ROLE_NAME
  );
};

export const editResidenceCommunityList = (data) => {
  // debugger;
  var ids = new Set(data?.menu?.map((d) => d.code));
  var mergedMenu = [
    ...data?.menu,
    // ...joinData?.joinMenuList.filter((d) => !ids.has(d.code)),
  ];
  return data?.userType === "Resident" ? { ...data, menu: mergedMenu } : data;
};

export const filterIncompleteCommunityList = (data) => {
  // debugger;
  return data?.find(
    (item) =>
      item.isSuperUser === true &&
      item.isSetupCompleted === false &&
      item?.roleName?.toLowerCase() !== DEFAULT_ROLE_NAME &&
      item?.userType !== "Resident"
  );
};
export const handleMaskedCNICInputChange = (form, name, e) => {
  let value = e?.target?.value?.replace(/\D/g, "");
  if (typeof e === "string" || typeof e === "number") {
    value = e?.replace(/\D/g, "");
  }
  if (value.length > 5) value = `${value.slice(0, 5)}-${value.slice(5)}`;
  if (value.length > 13) value = `${value.slice(0, 13)}-${value.slice(13, 14)}`;
  form.setFieldValue(name, value);
};
export const commaSeperator = (number) => {
  if (typeof number == "number") {
    return number.toLocaleString();
  } else {
    return 0;
  }
};
export const handleMaskedNumberInputChange = (value) => {
  let input = value?.toString().replace(/,/g, "");
  // let rawValue = "";
  let displayValue = "";
  if (!isNaN(input) && input !== "") {
    // rawValue = input;
    displayValue = Number(input).toLocaleString();
  } else if (input === "") {
    // rawValue = "";
    displayValue = "";
  }
  return displayValue;
};
export const activePackageStatus = (activePackage) => {

  console.log("ActivePackage ===>", activePackage)
  const inputDate = moment.utc(activePackage?.subscriptionEnd);
  const now = moment.utc();
  if (inputDate.isAfter(now) && activePackage?.isTrialPackage === false) {
    return "Extend Now";
  }
  // } else if (inputDate.isBefore(now) && activePackage?.isTrialPackage === false) {
  else if (!activePackage) {
    return "Renew Now";
  } else if (activePackage?.isTrialPackage === true) {
    return "Pay Now";
  }
  return "Renew Now"; // optional fallback
};
export const commaSeparator = (number) => {
  if (typeof number == "number") {
    return number.toLocaleString();
  } else {
    return number;
  }
};
export function countIncluding(start, end) {
  if (start < end) return end - start + 1;
  if (start === end) return 1;
  return 0;
}
export const statusCode200 = (response = null) =>
  response?.data?.headers?.code === 200;

export const handleApiResponse = (setter) => (response) => {
  if (!statusCode200(response)) return notOk(response);
  setter(response?.data?.body);
};

export const errorMessage = (response = null) => response?.data?.headers?.msg;
export const DateAndTimeformatter = (time) => {
  return moment.utc(time).local().format("DD MMM YYYY hh:mm A");
};
//not need of this function
const appendEleInToArray = (list, insertedList) => {
  const newArray = [...list];
  insertedList.forEach((item) => {
    if (item?.parentCode) {
      const parentIndex = newArray?.findIndex(
        (el) => el.code === item.parentCode
      );
      if (parentIndex !== -1) {
        const parent = newArray[parentIndex];
        const lastAccessId =
          parent.subModules.length > 0
            ? parent.subModules[parent.subModules.length - 1].accessId
            : parent.accessId;
        const newItem = {
          ...item,
          accessId: lastAccessId + 1,
          parentApplicationAccessId: parent.accessId,
        };
        newArray[parentIndex].subModules.push(newItem);
      }
    } else {
      newArray.push(item);
    }
  });
  return newArray;
};

const deleteSubModulesItem = (list, parentCode, subModuleCode) => {
  const newArray = [...list];
  // const allowedLabels = ["bankPaymentsApproval", "joinApproval", "bankPaymentsApproval"];
  const allowedLabels = [];
  for (let key in accessEnums) {
    allowedLabels.push(accessEnums[key].accessControlId);
  }
  // Find parent by parentCode
  const parentIndex = newArray.findIndex((el) => el.code === parentCode);
  if (parentIndex !== -1) {
    const parent = newArray[parentIndex];
    // Find subModule by subModuleCode
    const subModuleIndex = parent.subModules.findIndex(
      (subModule) => subModule.code === subModuleCode
    );

    if (subModuleIndex !== -1) {
      const subModule = parent.subModules[subModuleIndex];

      // Filter selectedApplicationAccessControlList to keep only items with allowed labels
      if (Array.isArray(subModule?.selectedApplicationAccessControlList)) {
        const isAnyApprovalSelected =
          subModule.selectedApplicationAccessControlList.some((obj) =>
            allowedLabels.includes(obj?.accessControlId)
          );
        if (!isAnyApprovalSelected) {
          newArray[parentIndex].subModules = newArray[
            parentIndex
          ].subModules.filter((subModule) => subModule.code !== subModuleCode);
        }
      }
    }
  }

  return newArray;
};

export const extractBalanceFromLabel = (labelString) => {
  // Extract number from format like "Hannan (Rs. 500)" or "Ali khan (Rs. 166,666,666)"
  const match = labelString.match(/\(Rs\.\s*([\d,]+)\)/);
  return match ? parseInt(match[1].replace(/,/g, "")) : 0;
};
export const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour >= 5 && hour < 12) {
    return "Good Morning !";
    // setGreeting('Good Morning');
  } else if (hour >= 12 && hour < 16) {
    return "Good Afternoon !";
    // setGreeting('Good Afternoon');
  } else if (hour >= 16 && hour < 21) {
    return "Good Evening !";
    // setGreeting('Good Evening');
  } else {
    return "Good Night !";
    // setGreeting('Good Night');
  }
};

// export const calculateRemainingMonthsAndDays = (inputUTC) => {
//   const targetDate = moment.utc(inputUTC).local();
//   const now = moment();

//   if (targetDate.isSameOrBefore(now)) {
//     return 'Expired';
//   }

//   let tempDate = moment(now);
//   let months = 0;

//   // Count full calendar months
//   while (tempDate.clone().add(1, "month").isSameOrBefore(targetDate)) {
//     tempDate.add(1, "month");
//     months++;
//   }

//   const remainingDays = targetDate.diff(tempDate, "days");

//   const monthLabel = months === 1 ? " month" : " months";
//   const dayLabel = remainingDays === 1 ? " day" : " days";

//   if (months === 0) {
//     return `${remainingDays}${dayLabel} left`;
//   }

//   if (remainingDays >= 15) {
//     return `${months + 1} ${monthLabel} left`;
//   } else if (remainingDays > 0) {
//     return `${months} ${monthLabel} ${remainingDays} ${dayLabel} left`;
//   } else {
//     return `${months} ${monthLabel} left`;
//   }
// };

export const calculateRemainingMonthsAndDays = (inputUTC) => {
  const targetDate = moment.utc(inputUTC); // Keep in UTC
  const now = moment.utc(); // Use UTC for current time

  if (targetDate.isSameOrBefore(now)) {
    return "Expired";
  }

  let tempDate = moment.utc(now); // Use UTC here too
  let months = 0;

  while (tempDate.clone().add(1, "month").isSameOrBefore(targetDate)) {
    tempDate.add(1, "month");
    months++;
  }

  // Use Math.ceil to round up partial days
  const remainingDays = Math.ceil(targetDate.diff(tempDate, "days", true));
  const monthLabel = months === 1 ? " month" : " months";
  const dayLabel = remainingDays === 1 ? " day" : " days";

  if (months === 0) {
    return `${remainingDays}${dayLabel} left`;
  }

  if (remainingDays >= 15) {
    return `${months + 1} ${monthLabel} left`;
  } else if (remainingDays > 0) {
    return `${months} ${monthLabel} ${remainingDays} ${dayLabel} left`;
  } else {
    return `${months} ${monthLabel} left`;
  }

  // Rest of your logic remains the same...
};

export const formatDurationFromDates = (startDate, endDate) => {
  const localStart = moment.utc(startDate).local();
  const localEnd = moment.utc(endDate).local();

  const totalMonths = localEnd.diff(localStart, "months");

  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;

  if (years > 0 && months >= 6) {
    return `${years + 1} year(s)`;
  } else if (years > 0 && months > 0) {
    return `${years} year(s) ${months} month(s)`;
  } else if (years > 0) {
    return `${years} year(s)`;
  } else {
    return `${totalMonths} month(s)`;
  }
};

export const formatSubscriptionDuration = (startDate, endDate) => {
  const start = moment(startDate);
  const end = moment(endDate);

  // Calculate the exact months (including partial months)
  const monthsExact = end.diff(start, "months", true); // true = float result
  const roundedMonths = Math.round(monthsExact);

  if (roundedMonths === 12) {
    return "1 year";
  } else if (roundedMonths > 12 && roundedMonths % 12 === 0) {
    return `${roundedMonths / 12} years`;
  } else if (roundedMonths > 12) {
    const years = Math.floor(roundedMonths / 12);
    const remainingMonths = roundedMonths % 12;
    return `${years} year${years > 1 ? "s" : ""} ${remainingMonths} month${remainingMonths > 1 ? "s" : ""
      }`;
  } else {
    return `${roundedMonths} month${roundedMonths !== 1 ? "s" : ""}`;
  }
};
export const formatDateToFullMonth = (dateStr) => {
  return moment(dateStr, "DD/MMM/YYYY").format("DD MMM YYYY");
};
export const formatInToLocalDate = (date) => moment(date).local().format("DD MMM YYYY");

/**
 * Safely convert a date string from one format to another
 * @param {string} dateStr - Input date string
 * @param {string} fromFormat - Expected input format (default "DD/MMM/YYYY")
 * @param {string} toFormat - Desired output format (default "D-MM-YYYY")
 * @returns {string} - Formatted date or empty string if invalid
 */
export const safeDateDashFormat = (
  dateStr,
  fromFormat = "DD/MMM/YYYY",
  toFormat = "DD-MM-YYYY"
) => {
  if (!dateStr) return "";

  console.log("DateStr", dateStr);
  const m = moment(dateStr, fromFormat, true); // strict parsing
  return m.isValid() ? m.format(toFormat) : "";
};
export function formatGroupedLabels(arr) {
  const months = [];
  let hasPreviousDues = false;
  for (let item of arr) {
    const [labelRaw, yearRaw] = item.split(",");
    const label = labelRaw.trim();
    const year = yearRaw.trim();
    if (label.toLowerCase() === "previous dues") {
      hasPreviousDues = true;
    } else {
      const shortMonth = getMonthShort(label);
      const shortYear = year.slice(2); // e.g. 2025 → '25'
      months.push(`${shortMonth} '${shortYear}`);
    }
  }
  // Special case: 1 previous due + 1 month → "Previous dues and Aug'25"
  if (hasPreviousDues && months.length === 1) {
    return `Previous dues and ${months[0]}`;
  }
  const result = [];
  if (hasPreviousDues) {
    result.push("Previous dues");
  }
  if (months.length > 0) {
    result.push(formatWithAnd(months));
  }
  return result.join(", ");
}
// Converts full month to short (e.g. August → Aug)
function getMonthShort(monthName) {
  const map = {
    January: "Jan",
    February: "Feb",
    March: "Mar",
    April: "Apr",
    May: "May",
    June: "Jun",
    July: "Jul",
    August: "Aug",
    September: "Sep",
    October: "Oct",
    November: "Nov",
    December: "Dec",
  };
  return map[monthName] || monthName;
}
// Formats list with "and" before last item
function formatWithAnd(list) {
  if (list.length === 1) return list[0];
  if (list.length === 2) return `${list[0]} and ${list[1]}`;
  return `${list.slice(0, -1).join(", ")} and ${list[list.length - 1]}`;
}


export const DateUtils = {
  // Create a safe moment instance with validation
  createMoment: (input, format = null) => {
    if (!input) return null;

    try {
      let momentObj;

      if (format) {
        // Use strict parsing when format is provided
        momentObj = moment(input, format, true);
      } else if (input instanceof Date) {
        momentObj = moment(input);
      } else if (typeof input === "string") {
        // For string inputs without format, try multiple formats
        const commonFormats = [
          "DD/MMM/YYYY",
          "DD-MM-YYYY",
          "YYYY-MM-DD",
          "MM/DD/YYYY",
          "DD/MM/YYYY",
        ];

        for (let fmt of commonFormats) {
          momentObj = moment(input, fmt, true);
          if (momentObj.isValid()) break;
        }

        // If still invalid, try default parsing
        if (!momentObj || !momentObj.isValid()) {
          momentObj = moment(input);
        }
      } else {
        momentObj = moment(input);
      }

      return momentObj.isValid() ? momentObj : null;
    } catch (error) {
      console.error("Error creating moment object:", error);
      return null;
    }
  },

  // Format date for display with cross-platform support
  formatForDisplay: (date) => {
    if (!date) return "";

    const momentObj = DateUtils.createMoment(date);
    if (!momentObj) return "";

    try {
      // return momentObj.format("DD/MMM/YYYY");
      return momentObj.format("DD MMM YYYY");
    } catch (error) {
      console.error("Error formatting date for display:", error);
      return "";
    }
  },

  // Format date for API with consistent format
  formatForApi: (date) => {
    if (!date) return "";

    const momentObj = DateUtils.createMoment(date);
    if (!momentObj) return "";

    try {
      // Use ISO format for maximum compatibility, then convert to required format
      return momentObj.format("DD-MM-YYYY");
    } catch (error) {
      console.error("Error formatting date for API:", error);
      return "";
    }
  },

  // Parse formatted date string to Date object
  parseToDate: (dateStr) => {
    if (!dateStr) return null;

    const momentObj = DateUtils.createMoment(dateStr);
    if (!momentObj) return null;

    try {
      return momentObj.toDate();
    } catch (error) {
      console.error("Error parsing date to Date object:", error);
      return null;
    }
  },

  // Validate if a date string is valid
  isValidDate: (dateStr, format = null) => {
    const momentObj = DateUtils.createMoment(dateStr, format);
    return momentObj !== null;
  },

  // Get current date in specified format
  getCurrentDate: (format = "DD/MMM/YYYY") => {
    try {
      return moment().format(format);
    } catch (error) {
      console.error("Error getting current date:", error);
      return "";
    }
  },

  // Get start of month in specified format
  getStartOfMonth: (format = "DD/MMM/YYYY") => {
    try {
      return moment().startOf("month").format(format);
    } catch (error) {
      console.error("Error getting start of month:", error);
      return "";
    }
  },

  // Create date range object for components like DateRangeField
  createDateRangeValue: (fromDate, toDate) => {
    const start = DateUtils.parseToDate(fromDate);
    const end = DateUtils.parseToDate(toDate);

    if (!start || !end) return null;

    return {
      selection: {
        startDate: start,
        endDate: end,
        key: "selection",
      },
    };
  },
};

export const sumByKey = (arr, key) => {
  if (!Array.isArray(arr) || arr.length === 0) return 0;

  return arr.reduce((sum, obj) => {
    const value = Number(obj?.[key]) || 0; // safely handle missing or non-numeric
    return sum + value;
  }, 0);
};


export function removeMiddlePart(str) {
  if (str) {
    const parts = str?.split("-");
    if (parts?.length !== 3) return str; // safeguard for unexpected formats
    return [parts?.[0], parts?.[2]]?.join("-");
  }
  return ""

}
export const formatTransactionDate = (dateString) => {
  const date = moment(dateString);

  if (!date.isValid()) {
    return "Invalid date"; // fallback
  }

  // Convert to local time and format as `MMM DD`
  return date.local().format("MMM DD");
};



export const formatTransactionDetailDate = (utcString) => {
  const date = moment.utc(utcString); // Parse as UTC

  if (!date.isValid()) {
    return "Invalid date"; // fallback
  }

  return date.local().format("D MMMM YYYY, h:mm A");
};

export const formatTransactionDateOnly = (utcString) => {
  const date = moment.utc(utcString); // Parse as UTC

  if (!date.isValid()) {
    return "Invalid date"; // fallback
  }

  return date.local().format("D MMMM YYYY");
};

export const checkSubscriptionExpiry = (selectedCommunity, setSubExpire) => {
  // :one: Safely read the end-date string
  const endDateStr = selectedCommunity?.dbSubscription?.subscriptionEnd;
  if (!endDateStr) {
    // If no date found, mark as not expired (or change based on business logic)
    store.dispatch(setSubscriptionExpired(false))
    // setSubExpire(false);
    return;
  }

  // :two: Convert to Date and compare with current time
  const endDate = new Date(endDateStr);
  const now = new Date();

  // :three: Set the state
  if (isNaN(endDate.getTime())) {
    // Invalid date format
    console.warn("Invalid subscriptionEnd format:", endDateStr);
    // setSubExpire(false);
    store.dispatch(setSubscriptionExpired(false))
    return;
  }

  store.dispatch(setSubscriptionExpired(endDate.getTime() < now.getTime()));
};


export const showSubsExpireAlert = () => {
  toast.error('Your subscription has expired. Renew now to unlock this feature again.')
}
export const calculateTotal = (arr, key) => arr?.reduce((sum, i) => sum + (i?.[key] ?? 0), 0) ?? 0;
export const notOk = (response,callback)=>{
  toast.error(response?.data?.headers?.msg);
  if(typeof callback === "function"){
    callback()
  }
}

export function deleteKeys(obj, keys = []) {
  if (!obj || typeof obj !== "object") return {};
  return Object.fromEntries(
    Object.entries(obj).filter(([key]) => !keys.includes(key))
  );
}

export const sortBillDate = (array = []) => {
  if (!Array.isArray(array)) return [];
  return [...array].sort((a, b) => {
    if (b.year === a.year) {
      return b.monthId - a.monthId; // Sort by month if year is same
    }
    return b.year - a.year; // Otherwise sort by year
  });
};


export function findValueFromTheSelectOptions(options = [], event,) {
  if (!Array.isArray(options) || !event?.target) return null;

  const label = event.target.innerHTML?.trim();
  return options.find(option => option?.label === label) || null;
}

// Usage
// const keysToRemove = ["totalCharges", "selectedDues", "paymentType", "balanceAmount"];
// const params = omitKeys(data, keysToRemove);


export function mapToSelectOptions(
  list,
  labelKey,
  valueKey,
  all=false
) {
  return list.map(item => ({
    label: item[labelKey],
    value: item[valueKey],
    ...(all &&{...item})
  }));
}

export function validateAndFormatDates(startDate, endDate, format = "DD-MM-YYYY") {
  const start = moment(startDate);
  const end = moment(endDate);

  // Validate dates
  if (!start.isValid() || !end.isValid()) return null;

  // If a format is provided, return formatted strings
  if (format) {
    return {
      start: start.format(format),
      end: end.format(format),
    };
  }

  // If no format is provided, return Moment objects
  return {
    start: start,
    end: end,
  };
}


export const createDateRangeValue = (date) => {
      const startDate = date?.fromDate;
      const endDate = date?.toDate;
      if (startDate && endDate) {
        return [
          {
            startDate,
            endDate,
            key: "selection",
          },
        ];
      }
    // Fallback to current month if parsing fails
return[null]
  };

  export const formatForDisplay= (date) => {
    if (!date) return "";

    const momentObj = DateUtils.createMoment(date);
    if (!momentObj) return "";

    try {
      // return momentObj.format("DD/MMM/YYYY");
      return momentObj.format("DD MMM YYYY");
    } catch (error) {
      console.error("Error formatting date for display:", error);
      return "";
    }
  }
export  const sumTransactions = (list = []) => {
  const getNumber = (value) =>
    typeof value === "number" ? value : parseFloat(value) || 0;

  return list.reduce(
    (acc, item) => {
      acc.totalCredit += getNumber(item?.credit);
      acc.totalDebit += getNumber(item?.debit);
      return acc;
    },
    { totalCredit: 0, totalDebit: 0 }
  );
};
// ──────────────────────────────────────────────────────────────
// 1. Pure pricing logic — isolated, testable, reusable
// ──────────────────────────────────────────────────────────────
export const calculateDiscountArrow = (amount, percent) => (amount * percent) / 100;
export const calculatePackagePrice = (
  pkg,
  mainUnits,
  additionalUnits,
  perUnitPrice
) => {
  const individualTotalUnitsPrice =
    parseInt(mainUnits) * perUnitPrice * parseInt(pkg?.packageDurationMonths);
  const months = Number(pkg.packageDurationMonths);
  const base = Number(pkg.baseAmount) || 50;
  const unitsPrice = mainUnits * perUnitPrice * months;
  const total = base + unitsPrice;
  const discount = calculateDiscountArrow(total, pkg.discountPercentage || 0);
  const final = total - discount;
  const perPrice = parseInt(mainUnits);

  return {
    total,
    discount,
    final: Math.round(final), // Never trust floating point with money
    perMonth: months 
  };
};
// export const sliderColor = (thumbAndTrackColor, railColor = "#e0e0e0") => ({
//   color: "var(--main-color-dark)",

//   "& .MuiSlider-thumb": {
//     backgroundColor: "var(--main-color-dark)"
//   },

//   "& .MuiSlider-track": {
//     backgroundColor: "rgb(144, 121, 251)",
//   },

//   "& .MuiSlider-rail": {
//     backgroundColor: "rgb(144, 121, 251)",
//   },
// });


export const sliderColor = ({
  track = "#cfc5ff",
  inner = "#9f8aff",
  glow = "rgba(159, 138, 255, 0.35)",
} = {}) => ({
  height: 6,
  padding: "15px 0",

  "& .MuiSlider-rail": {
    opacity: 1,
    backgroundColor: track,
    borderRadius: 10,
  },

  "& .MuiSlider-track": {
    backgroundColor: track,
    border: "none",
    borderRadius: 10,
  },

  "& .MuiSlider-thumb": {
    height: 22,
    width: 22,
    backgroundColor: "#fff", // outer ring
    border: "2px solid #fff",
    boxShadow: `0 0 12px ${glow}`,
    position: "relative",

    "&:before": {
      content: '""',
      position: "absolute",
      inset: 5,           // inner circle size
      backgroundColor: inner,
      borderRadius: "50%",
    },
  },
});